import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getReportPDFLoading, getReportData, getReportLoading } from 'src/module/device/selector';
import { usePDFServices as checkPDFServices } from 'src/utils/utils';

/**
 * Hook for managing PDF services availability
 * @returns Object with usePDFServicesValue and usePDFServicesLoading
 */
export const usePDFServices = () => {
  const [usePDFServicesValue, setUsePDFServicesValue] = useState<boolean | null>(null);
  const [usePDFServicesLoading, setUsePDFServicesLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      const result = await checkPDFServices();
      setUsePDFServicesValue(result);
      setUsePDFServicesLoading(false);
    }
    loadData();
  }, []);

  return { usePDFServicesValue, usePDFServicesLoading };
};

/**
 * Hook that combines report data, loading, and PDF loading selectors
 * @param reportType - The type of report ('multi', 'regulator', etc.)
 * @returns Object with data, loading, and pdfLoading
 */
export const useReportData = (reportType: string) => {
  const data = useSelector(getReportData(reportType));
  const loading = useSelector(getReportLoading);
  const pdfLoading = useSelector(getReportPDFLoading);

  return { data, loading, pdfLoading };
};
